import PageWrapper from 'hoc/PageWrapper'
import { Box, Card, Grid, styled, Typography } from '@mui/material'
import { ETenderType } from 'types/tender'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

const StyledCard = styled(Card)({
  height: 300,
  width: '100%',
  cursor: 'pointer',
  transition: 'opacity .25s',
  '&:hover': {
    opacity: 0.7,
  },
})

export const ManagementDashboard = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleTenderClick = useCallback(
    (tenderType: ETenderType) => {
      navigate(`/portal/tenders?type=${tenderType}`)
    },
    [navigate]
  )

  return (
    <PageWrapper>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <StyledCard
            onClick={() => handleTenderClick(ETenderType.OPEN_TENDER)}
            elevation={3}
          >
            <Box
              display="flex"
              width="100%"
              height="100%"
              fontSize="56px"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <AddCircleOutlineIcon color="primary" fontSize="inherit" />
              <Typography variant="h5" sx={{ mt: 2 }} color="primary.main">
                {t('OPEN_TENDER_short')}
              </Typography>
            </Box>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <StyledCard
            onClick={() => handleTenderClick(ETenderType.PRICE_INQUIRY)}
            elevation={3}
          >
            <Box
              display="flex"
              width="100%"
              height="100%"
              fontSize="56px"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <AddCircleOutlineIcon color="primary" fontSize="inherit" />
              <Typography variant="h5" sx={{ mt: 2 }} color="primary.main">
                {t('PRICE_INQUIRY_short')}
              </Typography>
            </Box>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <StyledCard
            onClick={() => handleTenderClick(ETenderType.TWO_STAGE_TENDER)}
            elevation={3}
          >
            <Box
              display="flex"
              width="100%"
              height="100%"
              fontSize="44px"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <AddCircleOutlineIcon color="primary" fontSize="inherit" />
              <Typography variant="h5" sx={{ mt: 2 }} color="primary.main">
                {t('TWO_STAGE_TENDER_short')}
              </Typography>
            </Box>
          </StyledCard>
        </Grid>
      </Grid>
    </PageWrapper>
  )
}
